import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    eventsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    eventsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setEventsList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { eventsLoading, eventsError, setEventsList } =
  eventsSlice.actions;

export default eventsSlice.reducer;
